import { Spinner } from "@aurem/ui";
import type { FC, RefObject } from "react";
import { MessageFromEnum, MessageStatusEnum, StreamState } from "types";
import { ThreadMessage } from "..";
import { AssistantMessageCompleted } from "./AssistantMessage/AssistantMessageCompleted";
import { AssistantMessageInProgress } from "./AssistantMessage/AssistantMessageInProgress";
import { UserMessage } from "./UserMessage";

export const ChatMessages: FC<{
  messages: ThreadMessage[];
  streamingState: StreamState | null;
  messagesEndRef: RefObject<HTMLDivElement | null>;
  onRetryMessage?: (messageContent: string, currentRetryCount: number) => void;
  isThinking?: boolean;
  isLoadingMore?: boolean;
  variant?: "panel" | "fullscreen";
}> = ({
  messages,
  messagesEndRef,
  streamingState,
  onRetryMessage,
  isThinking,
  isLoadingMore = false,
  variant = "panel",
}) => {
  return (
    <div className="p-4 space-y-3">
      {isLoadingMore && (
        <div className="flex justify-center py-2">
          <Spinner size="sm" />
        </div>
      )}
      {messages.map((message) => {
        if (message.from === MessageFromEnum.User) {
          return (
            <UserMessage
              key={message.id}
              message={message}
              variant={variant}
              onRetry={
                onRetryMessage && !isThinking
                  ? () =>
                      onRetryMessage(message.content, message.retryCount ?? 0)
                  : undefined
              }
            />
          );
        }

        if (message.from === MessageFromEnum.Assistant) {
          return (
            <div key={message.id}>
              {message.status === MessageStatusEnum.Processing ? (
                <AssistantMessageInProgress streamingState={streamingState} />
              ) : (
                <AssistantMessageCompleted
                  message={message}
                  variant={variant}
                />
              )}
            </div>
          );
        }

        return null;
      })}

      <div ref={messagesEndRef} />
    </div>
  );
};
